module.exports = __webpack_public_path__ + "public/images/icon-download.dd9798304f9a706aec0af7560d8fd566.svg";